
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core",
      function () {
        return require("private-next-pages/core.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core"])
      });
    }
  